import FilterSelect from './FilterSelect'
import FilterText from './FilterText'
import FilterDate from './FilterDate'
import FilterToggle from './FilterToggle'
import AtmosphereIcon from '../../icons/Atmosphere'
import BodyIcon from '../../icons/Body'
import ColorIcon from '../../icons/Color'
import EyeIcon from '../../icons/Eye'
import FaceIcon from '../../icons/Face'
import GlassesIcon from '../../icons/Glasses'
import HatIcon from '../../icons/Hat'
import MouthIcon from '../../icons/Mouth'
import SearchIcon from '../../icons/Search'
import BirthdayIcon from '../../icons/Birthday'
import WalletIcon from '../../icons/Wallet'

function Filters({
    values,
    setFilters,
    onNameChange,
    nameValue,
    apiQuery,
    onChangeDay,
    onChangeMonth,
    onChangeYear,
    onClearBirthday,
    onChangeOnlyMine,
    mine,
    totalMine,
}) {
    return (
        <>
            <FilterText
                icon={<SearchIcon />}
                value={nameValue}
                onChange={onNameChange}
            />
            <FilterSelect
                icon={<AtmosphereIcon />}
                name="Atmosphere"
                values={values}
                filters={apiQuery.atmosphere}
                type="atmosphere"
                setFilters={setFilters}
            />
            <FilterSelect
                icon={<BodyIcon />}
                name="Body"
                type="body"
                values={values}
                filters={apiQuery.body}
                setFilters={setFilters}
            />
            <FilterSelect
                icon={<ColorIcon />}
                name="Color"
                type="color"
                values={values}
                filters={apiQuery.color}
                setFilters={setFilters}
            />
            <FilterSelect
                icon={<EyeIcon />}
                name="Eye Color"
                type="eye_color"
                values={values}
                filters={apiQuery.eye_color}
                setFilters={setFilters}
            />
            <FilterSelect
                icon={<FaceIcon />}
                name="Face"
                type="face"
                values={values}
                filters={apiQuery.face}
                setFilters={setFilters}
            />
            <FilterSelect
                icon={<GlassesIcon />}
                name="Glasses"
                type="glasses"
                values={values}
                filters={apiQuery.glasses}
                setFilters={setFilters}
            />
            <FilterSelect
                icon={<HatIcon />}
                name="Hat"
                type="hat"
                values={values}
                filters={apiQuery.hat}
                setFilters={setFilters}
            />
            <FilterSelect
                icon={<MouthIcon />}
                name="Mouth"
                type="mouth"
                values={values}
                filters={apiQuery.mouth}
                setFilters={setFilters}
            />
            <FilterDate
                icon={<BirthdayIcon />}
                name="Birthday"
                onClearBirthday={onClearBirthday}
                onChangeDay={onChangeDay}
                onChangeMonth={onChangeMonth}
                onChangeYear={onChangeYear}
                day={apiQuery.day}
                month={apiQuery.month}
                year={apiQuery.year}
            />
            {totalMine > 0 && (
                <FilterToggle
                    name="My wallet"
                    icon={<WalletIcon />}
                    count={totalMine}
                    toggleName="Only mine"
                    checked={mine}
                    onChange={onChangeOnlyMine}
                />
            )}
        </>
    )
}

export default Filters
